<template>
  <div>
    <div class="mb20">页面来源：{{ $router.history._startLocation }}</div>
    <img :src="imgArr.error404" style="width: 100%; height: 99%;">
  </div>
</template>
<script>
import { imgArr } from '@/assets/images/img'
export default {
  data(){
    return{
      imgArr: imgArr
    }
  },
  created(){
    // console.log(this.$router,2222);
  },
}
</script>